import { ColorsStorage } from "./Constant/ColorsStorage";

export const createAllGraphsColor = ({ channels, brands }) => {
  const darkThemeColor = generateDifferentThemeColor({
    channels,
    brands,
    type: "dark",
  });
  const lightThemeColor = generateDifferentThemeColor({
    channels,
    brands,
    type: "light",
  });
  localStorage.setItem("colors", JSON.stringify(darkThemeColor));
  localStorage.setItem("secondaryColors", JSON.stringify(lightThemeColor));
};

const generateDifferentThemeColor = ({ channels, brands, type }) => {
  let allChannelsColor = [],
    allChannelsBorderColor = [],
    allBrandsColor = [],
    allBrandsBorderColor = [];

  if (type === "dark") {
    allChannelsColor = ColorsStorage.color.fill;
    allChannelsBorderColor = ColorsStorage.color.border;
    allBrandsColor = ColorsStorage.color.brand;
    allBrandsBorderColor = ColorsStorage.color.brand_border;
  } else {
    allChannelsColor = ColorsStorage.secondary_color.fill;
    allChannelsBorderColor = ColorsStorage.secondary_color.border;
    allBrandsColor = ColorsStorage.secondary_color.brand;
    allBrandsBorderColor = ColorsStorage.secondary_color.brand_border;
  }

  let channelsColor = [],
    channelsBorderColor = [],
    brandsColor = [],
    brandsBorderColor = [];

  channels.forEach((channel, i) => {
    const safeIndex = i % allChannelsColor.length;
    channelsColor.push({
      name: channel,
      color: allChannelsColor[safeIndex],
    });
    channelsBorderColor.push({
      name: channel,
      color: allChannelsBorderColor[safeIndex],
    });
  });

  brands.forEach((brand, i) => {
    const safeIndex = i % allBrandsColor.length;
    brandsColor.push({
      name: brand,
      color: allBrandsColor[safeIndex],
    });
    brandsBorderColor.push({
      name: brand,
      color: allBrandsBorderColor[safeIndex],
    });
  });

  return {
    fill: channelsColor,
    border: channelsBorderColor,
    brand: brandsColor,
    brand_border: brandsBorderColor,
  };
};
